<script>
export default {
  name: "title-value-wrapper",
  props: {
    title: String,
    value: String,
    renderAsHtml: Boolean,
  },
  data: function() {
    return {};
  },
  computed: {
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
  },
};
</script>
<template>
  <div>
    <span class="title-text" :class="[isSmallScreen ? 'small-title-text' : '']">{{ title }}</span
    ><br />
    <span v-if="!renderAsHtml" :class="[isSmallScreen ? 'content-text-small' : 'content-text']">{{ value }}</span>
    <span v-else :class="[isSmallScreen ? 'content-text-small' : 'content-text']" v-html="value"></span>
  </div>
</template>
<style scoped>
.content-text {
  font-size: 14px;
}
.content-text-small,
.small-title-text {
  font-size: 12px;
}
</style>
